import { FlameMark } from "./Logo";
import { scrollToId } from "../lib/api";

export default function Footer({ categories, settings = { address: "", phone: "", whatsapp: "" } }) {
  return (
    <footer className="relative border-t border-ember/15 bg-card/30">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <FlameMark className="h-9 w-9" />
              <span className="leading-none">
                <span className="block font-display font-bold tracking-[0.18em] text-starlight text-xl">UTSAV</span>
                <span className="block font-mono text-[10px] tracking-[0.42em] text-ember mt-1">CRACKERS</span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-night">
              Authentic quality fireworks from our family shop — hand-picked, hand-packed and
              delivered to your doorstep.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-ember">Shop</p>
            <ul className="mt-5 space-y-2.5">
              {categories.slice(0, 5).map((c) => (
                <li key={c.slug}>
                  <button
                    onClick={() => scrollToId("shop")}
                    className="text-sm text-muted-night hover:text-ember transition-colors"
                  >
                    {c.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-ember">Find us</p>
            <ul className="mt-5 space-y-2.5 text-sm text-muted-night" data-testid="footer-contact">
              {settings.address && <li className="leading-relaxed whitespace-pre-line">{settings.address}</li>}
              {settings.phone && <li>Call: {settings.phone}</li>}
              {settings.whatsapp && <li>WhatsApp: {settings.whatsapp}</li>}
              {settings.email && <li>Email: {settings.email}</li>}
              {!settings.address && !settings.phone && !settings.whatsapp && !settings.email && <li>Contact details coming soon</li>}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-ember">Good to know</p>
            <ul className="mt-5 space-y-2.5 text-sm text-muted-night">
              <li>
                <a href="/track" data-testid="footer-track-link" className="text-starlight hover:text-ember transition-colors">
                  Track your order →
                </a>
              </li>
              <li>Cash on delivery — pay when it arrives</li>
              <li>Free packing on orders above ₹2,000</li>
              <li>Open, ventilated storage is safest</li>
              <li>Sold only to persons 18 and above</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-starlight/10 pt-6">
          <p className="font-mono text-[11px] text-muted-night">© 2025 Utsav Crackers. All sparks reserved.</p>
          <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-muted-night/70">
            Light only in open spaces • Keep water nearby
          </p>
        </div>
      </div>
    </footer>
  );
}
